import { Datagrid, FunctionField, List, TextField, DateField } from "react-admin";

type Binding = {
  id: string;
  username: string | null;
  phone: string | null;
  telegram_id: number | null;
  promo_code: string;
  promo_bound_at: string | null;
};

export function PromoBindingList() {
  return (
    <List perPage={50} sort={{ field: "promo_bound_at", order: "DESC" }} exporter={false}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <FunctionField label="Пользователь" render={(r: Binding) => r.username || r.phone || r.telegram_id || r.id} />
        <TextField source="phone" label="Телефон" />
        <TextField source="promo_code" label="Промокод" />
        <DateField source="promo_bound_at" label="Привязан" showTime />
      </Datagrid>
    </List>
  );
}
